var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickClientBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.90067 10.1597L0.900672 7.15971C0.509672 6.76871 0.509672 6.13671 0.900672 5.74571C1.29167 5.35471 1.92367 5.35471 2.31467 5.74571L4.55067 7.98171L10.8487 0.802712C11.2087 0.382712 11.8397 0.334712 12.2577 0.693712C12.6777 1.05371 12.7267 1.68371 12.3667 2.10271L5.36667 10.1027C5.18567 10.3147 4.92367 10.4407 4.64567 10.4517C4.34267 10.4527 4.08767 10.3477 3.90067 10.1597Z",
    fill: "#489767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickClientBtn);
export default __webpack_public_path__ + "static/media/tickClientBtn.af85553b4f2b0bd522aa8e733263ac1a.svg";
export { ForwardRef as ReactComponent };